<div class="field field-radios d-flex flex-column" [class.hasOptionWidth]="!optionWidth || optionColumnWidth" [class.readOnly]="readOnly">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <div class="{{!optionWidth && optionColumnWidth ? 'row' : 'd-flex'}} options">
    @for (option of options; track option) {
      <div class="col-lg-{{(!optionWidth && optionColumnWidth) || ''}}" [class.flex-grow-1]="fillWidth">
        <div [class.error-field]="error" [ngStyle]="{'min-width': !optionColumnWidth && optionWidth ? (optionWidth + 'px') : 'auto'}" (click)="(canUncheck && option.value == model) ? emit(undefined) : emit(option.value)" [class.active]="option.value === model" [class.disabled]="option.disabled" class="field-radio-option flex-grow-1 d-flex align-items-center">
          <span class="fake-radio"></span> <span class="ellipsis option-title" [title]="option.title">{{option.title}}</span>
        </div>
      </div>
    }
  </div>
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>